import { render } from "./WritingActa.vue?vue&type=template&id=e693c0ac"
import script from "./WritingActa.vue?vue&type=script&lang=js"
export * from "./WritingActa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__